import { motion,  useInView } from "framer-motion";
import { useRef } from "react";
interface AboutUs_panelProps {
  image?:string;
  title: {
    text: string, color: string
  };
  subtitle: {
    text: string,
    color: string
  };
  contexts: {
    text: string[],
    color: string
  };
  // button: string;
}
const AboutUs_panel: React.FC<AboutUs_panelProps> = ({image, title, subtitle, contexts }) => {
  const Ref = useRef(null);
  const InView = useInView(Ref, { once: false, amount: 0.2 });
  console.log({contexts});

  return (
    <motion.div
      className="contain w-full h-auto flex flex-col items-start justify-center  gap-4 p-2 sm:p- z-10 relative"
    >
      <div className={`${image ? "":"hidden"} w-[212px] h-[131px] absolute right-0 -top-10`}>
        <img src={image} alt="blue logo" className="w-full h-auto hidden sm:block  " />
      </div>
      <div className={`border-l-2 border-[${title.color}] px-2 text-[${title.color}] font-bold text-[30px] font-bungeeinline`}>{title.text}</div>
      <div className={`font-bold text-[${subtitle.color}] font-bungeeinline text-2xl sm:text-4xl  uppercase`}>{subtitle.text}</div>
      {contexts.text.map((context, index) => (
        <motion.div
          ref={Ref}
          initial="hidden"
          animate={InView ? "visible" : "visible"}
          variants={{
            hidden: { opacity: 0, y: 50 },
            visible: { opacity: 1, y: 0, transition: { duration: 2, type: "spring", bounce: 0 } },
          }}
          key={index}
          className={`text-[${contexts.color}] text-lg sm:text-xl md:text-2xl lg:text-3xl`}>
          {context}
        </motion.div>
      ))}

    </motion.div>

  );
};
export default AboutUs_panel;
